import styled from "styled-components";

export const ExampleQuestionsContainer = styled.div`
    margin-top: 15px;
`;

export const FilterListContainer = styled.div`
    display: flex;
    flex-direction: column;
    opacity: 0;
    transform: translateY(20px);
    transition: opacity 0.4s ease, transform 0.4s ease;

    &.visible {
        opacity: 1;
        transform: translateY(0);
    }
`;

export const FilterListEnd = styled.div`
    opacity: 0;
`;

export const ExampleQuestions = styled.div`
    display: flex;
    align-items: center;
`;
